import {
  STR_MUTATION_ID_UPDATE_STOREFRONT,
  STR_MUTATION_UPDATE_PRODUCT,
  STR_MUTATION_ADD_TO_CART,
  STR_MUTATION_REMOVE_FROM_CART,
  STR_MUTATION_SET_CART_ITEM_QUANTITY,
  STR_MUTATION_UPDATE_ORDER,
  STR_MUTATION_RESET_CART_STATE,
  STR_MUTATION_RESET_ORDER_STATE,
  STR_MUTATION_RESET_INVENTORY_STATE,
  STR_MUTATION_SET_PARENT_PASSCODE,
  STR_MUTATION_SET_SHIPPING_ADDRESS_COUNTRY
} from "./mutation-types";
import { updateField } from "vuex-map-fields";
export default {
  // storefront
  [STR_MUTATION_ID_UPDATE_STOREFRONT](state, inOStorefront) {
    state.storefront = Object.assign({}, state.storefront, inOStorefront);
  },
  // products
  [STR_MUTATION_UPDATE_PRODUCT](state, inOProduct) {
    const productIdx = state.products.findIndex(
      product => product.id === inOProduct.id
    );
    if (productIdx !== -1) {
      state.products.splice(productIdx, 1, inOProduct);
    } else {
      state.products.push(inOProduct);
    }
  },
  // cart
  [STR_MUTATION_ADD_TO_CART](state, inProductId) {
    const productCartItemIdx = state.cart.items.findIndex(
      product => product.productId === inProductId
    );
    const product = state.products.find(product => product.id === inProductId);
    if (!product) throw new Error("Product not found. Cannot add to cart");

    const tracksInventory = product.is_stock_tracked;
    const countBaseStock = product.stock;
    // if stock is tracked, update our local inventory levels
    if (tracksInventory) {
      // here, we'll setup a simple local inventory tracker for this
      // product the first time it is added to the cart
      // we'll also do a server side check before purchasing,
      // to account for stock changes from other orders
      if (typeof state.inventory[inProductId] === "undefined") {
        const inventory = state.inventory;
        inventory[inProductId] = countBaseStock;
        state.inventory = Object.assign({}, state.inventory, inventory);
      }
      // really, the callee should check this, but just in case
      if (state.inventory[inProductId] === 0) {
        throw new Error("Cannot add product to cart. No stock left");
      }
      state.inventory[inProductId]--;
    }
    // add the item to the cart
    // if it already exists, increment quantity
    if (productCartItemIdx !== -1) {
      state.cart.items[productCartItemIdx].quantity++;
    } else {
      state.cart.items.push({
        productId: inProductId,
        quantity: 1
      });
    }
  },
  [STR_MUTATION_REMOVE_FROM_CART](state, inProductId) {
    const productCartItemIdx = state.cart.items.findIndex(
      product => product.productId === inProductId
    );
    const product = state.products.find(product => product.id === inProductId);
    if (!product) throw new Error("Product not found. Cannot remove from cart");
    const curCartQuantity = state.cart.items[productCartItemIdx].quantity;
    if (productCartItemIdx !== -1) {
      state.cart.items.splice(productCartItemIdx, 1);
    }

    const tracksInventory = product.is_stock_tracked;
    // if we're tracking inventory for this product, increment inventory levels
    // based upon the quantity removed from the cart
    if (tracksInventory) {
      if (!Number.isNaN(state.inventory[inProductId])) {
        state.inventory[inProductId] += curCartQuantity;
      }
    }
  },
  [STR_MUTATION_SET_CART_ITEM_QUANTITY](state, inProductId, inIntQuantity) {
    if (
      isNaN(inIntQuantity) ||
      Math.sign(inIntQuantity) !== 1 ||
      !Number.isInteger(inIntQuantity)
    ) {
      throw new Error(`Invalid cart item quantity: ${inIntQuantity}`);
    }
    const productCartItemIdx = state.cart.items.findIndex(
      product => product.productId === inProductId
    );
    if (productCartItemIdx !== -1) {
      const newCartItemState = state.cart.items[productCartItemIdx];
      newCartItemState.quantity = inIntQuantity;
      state.cart.items.splice(productCartItemIdx, 1, newCartItemState);
    }
  },
  [STR_MUTATION_UPDATE_ORDER](state, inOrder) {
    state.order = Object.assign({}, state.order, inOrder);
  },
  [STR_MUTATION_RESET_CART_STATE](state, inDefaultState) {
    state.cart = Object.assign({}, inDefaultState);
  },
  [STR_MUTATION_RESET_ORDER_STATE](state, inDefaultState) {
    state.order = Object.assign({}, inDefaultState);
  },
  [STR_MUTATION_RESET_INVENTORY_STATE](state, inDefaultState) {
    state.inventory = Object.assign({}, inDefaultState);
  },
  [STR_MUTATION_SET_SHIPPING_ADDRESS_COUNTRY](state, inCountryCode) {
    state.forms.shippingForm.formAttributes.shipping_country = inCountryCode;
  },
  // META
  [STR_MUTATION_SET_PARENT_PASSCODE](state, inStrPasscode) {
    state.meta.parent_passcode = inStrPasscode;
  },
  updateField
};
